

export const experimentOverlayOptions = [
  { label: "STUDIO.SHARE_ACTION", key: "share", callBack: "shareAction", disable: false },
  { label: "STUDIO.CLONE_ACTION", key: "clone", callBack: "cloneAction", disable: false },
  {
    label: "STUDIO.PUBLISH",
    key: "publish",
    callBack: "publishAndUnpublishAction",
    disable: false
  },
  { label: "STUDIO.DELETE_ACTION", key: "delete", callBack: "deleteAction", disable: false }
];

export const myExperimentOverlayOptions = [
  {
    label: "STUDIO.SHARE_ACTION",
    icon: "icon-share.svg",
    key: "share",
    callBack: "shareAction",
    callBackbulk: "bulkShareActionCall",
    disable: false
  },
  {
    label: "STUDIO.CLONE_ACTION",
    icon: "icon-clone.svg",
    key: "clone",
    callBack: "cloneAction",
    callBackbulk: "bulkCloneActionCall",
    disable: false
  },
  {
    label: "STUDIO.PUBLISH",
    icon: "icon-publish.svg",
    key: "publish",
    callBack: "publishAndUnpublishAction",
    callBackbulk: "bulkPublishAndUnPublishActionCall",
    disable: false
  },
  {
    label: "STUDIO.MOVE_TO",
    icon: "icon-move.svg",
    key: "move",
    callBack: "moveAction",
    callBackbulk: "bulkMoveActionCall",
    disable: false
  },
  // {
  //   label: "Add tag",
  //   icon: "icon-tag.svg",
  //   key: "add-tag",
  //   callBack: "addTagAction",
  //   callBackbulk: "bulkAddTagActionCall",
  //   disable: true,
  // },
  // {
  //   label: "Favorite",
  //   icon: "icon-favorite.svg",
  //   key: "favorite",
  //   callBack: "favoriteAction",
  //   callBackbulk: "bulkFavoriteActionCall",
  //   disable: true,
  // },
  {
    label: "STUDIO.DELETE_ACTION",
    icon: "icon-delete.svg",
    key: "delete",
    callBack: "deleteAction",
    callBackbulk: "bulkDeleteActionCall",
    disable: false
  },
  {
    label: "STUDIO.STATUS",
    icon: "",
    key: "status",
    callBack: "statusAction",
    callBackbulk: "bulkStatusActionCall",
    disable: false
  }
];

export const sharedExperimentOverlayOptions = [
  { label: "STUDIO.CLONE_ACTION", key: "clone", callBack: "cloneAction", disable: false },
  {
    label: "STUDIO.PUBLISH",
    key: "publish",
    callBack: "publishAndUnpublishAction",
    disable: false
  },
  {
    label: "STUDIO.MOVE_TO",
    key: "move",
    callBack: "moveAction",
    disable: false
  }
];

export const keysToSelectedFolder = [
  "id",
  "name",
  "owner_id",
  "parent_id",
  "updated_at",
  "created_at",
  "full_path",
  "ancestor_ids",
  "shared_users"
];

